import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // uses localStorage
import userReducer from './Slices/userSlice';
import symbolReducer from './Slices/symbolSlice'
import modalReducer from './Slices/modalSlice'
import { combineReducers } from 'redux';
import newsReducer from './Slices/newsSlice'
import accountReducer from './Slices/accountTree'
import orderPositionReducer from './Slices/orderPositionSlice';
import watchListReducer from './Slices/watchList';
import emailReducer from './Slices/emailsSlice';
import alertReducer from './Slices/alertSlice';
import accountSummaryReducer from './Slices/accountSummary'
import symbolGroupUnitReducer from './Slices/symbolGroupUnitSlice';
import globalSymbolReducer from './Slices/globalSymbolSlice';
import profitLossReducer from './Slices/profitLossSlice';

const persistConfig = {
  key: 'root',
  storage,
  // blacklist: ['watchlist'],
  whitelist: ['user',"symbol"]
};

const rootReducer = combineReducers({
  user: userReducer,
  symbol: symbolReducer,
  modal: modalReducer,
  news: newsReducer,
  accountTree: accountReducer,
  orderPosition: orderPositionReducer,
  watchlist: watchListReducer,
  email: emailReducer,
  alert: alertReducer,
  accountSummary: accountSummaryReducer,
  groupUnit:symbolGroupUnitReducer,
  globalSymbol:globalSymbolReducer,
  profitLoss:profitLossReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
});

const persistor = persistStore(store);

export { store, persistor };